import { AchievementCondition } from "./achievement_conditions_class";
import { OccurrenceFrequencyLevel } from "./dates/occurrence_frequency";
import { GoalTemplate } from "./goal_template_class";
import { PatientGoalType } from "./patient_goal_type_class";
import * as convert from "xml-js";
import { AchievementConditionShape } from "../interfaces/classTypes";

let allPatientGoals = [];
let removedPatientGoals = [];
let selectedPatientGoals = [];
export class PatientGoal {
  public achievementCondition: AchievementConditionShape;
  public achievementProgress: number | null;
  public achievementTarget: number;
  public achievementThreshold: number;
  public active: boolean;
  public continuous: boolean;
  public createdAt: any;
  public deactivatedAt: any;
  public description: string;
  public endDate: string;
  public goalTemplate: any;
  public goalTemplateId: number;
  public hasErrors: boolean;
  public id: number | null;
  public initialReading: any;
  public leaderboardEnabled: boolean;
  public leaderboardIncluded: boolean;
  public monitorProfileId: number;
  public name: string;
  public occurrenceAmount: number | null;
  public occurrenceFrequency: string;
  public selectedForSaving: boolean;
  public startDate: any;
  public type: any;
  public updatedAt: any;

  constructor({
    achievementCondition,
    achievementProgress = null,
    achievementTarget,
    achievementThreshold,
    active = false,
    continuous,
    createdAt = null,
    deactivatedAt = null,
    description,
    goalTemplateId,
    id = null,
    initialReading = null,
    leaderboardEnabled = false,
    leaderboardIncluded = false,
    monitorProfileId,
    name,
    occurrenceAmount,
    occurrenceFrequency,
    startDate,
    endDate,
    updatedAt,
    type,
  }: any) {
    this.achievementCondition =
      AchievementCondition.findByName(achievementCondition);
    this.achievementProgress = achievementProgress;
    this.achievementTarget = achievementTarget;
    this.achievementThreshold = achievementThreshold;
    this.active = active;
    this.continuous = continuous;
    this.createdAt = createdAt;
    this.deactivatedAt = deactivatedAt;
    this.description = description;
    this.endDate = endDate;
    this.goalTemplateId = goalTemplateId;
    this.id = id;
    this.initialReading = initialReading;
    this.leaderboardEnabled = leaderboardEnabled;
    this.leaderboardIncluded = !this.leaderboardEnabled
      ? false
      : leaderboardIncluded;
    this.monitorProfileId = monitorProfileId;
    this.name = name;
    this.occurrenceAmount = occurrenceAmount == null ? 0 : occurrenceAmount;
    this.occurrenceFrequency =
      OccurrenceFrequencyLevel.findByName(occurrenceFrequency);
    this.updatedAt = updatedAt;
    this.goalTemplate = GoalTemplate.findById(this.goalTemplateId);
    this.hasErrors = this.goalTemplate.hasErrors;
    this.type = PatientGoalType.findByName(type);
    this.startDate = startDate;
    this.save();
  }

  hasLeaderboardsEnabled() {
    return this.leaderboardEnabled;
  }

  isStaticGoal() {
    return !(
      this.achievementCondition.name == "increasing_by" ||
      this.achievementCondition.name == "decreasing_by"
    );
  }

  includeInLeaderboards() {
    return (this.leaderboardIncluded = true);
  }

  setLeaderboardStatus(state) {
    return (this.leaderboardIncluded = state);
  }

  excludeFromLeaderboards() {
    return (this.leaderboardIncluded = false);
  }

  isExistingGoal() {
    return this.id ? true : false;
  }

  save() {
    allPatientGoals.push(this);
  }

  formatForSave() {
    let options = { compact: true, ignoreComment: true, spaces: 0 };
    let formattedPayload = convert.json2xml(JSON.stringify(this), options);
    return formattedPayload;
  }

  selectForSaving() {
    removedPatientGoals = removedPatientGoals.filter(
      (goal) => goal.goalTemplateId != this.goalTemplateId
    );
    if (
      !selectedPatientGoals.find(
        (goal) => goal.goalTemplateId == this.goalTemplateId
      )
    ) {
      selectedPatientGoals.push(this);
    }
  }

  selectForDeletion() {
    selectedPatientGoals = selectedPatientGoals.filter(
      (goal) => goal.goalTemplateId != this.goalTemplateId
    );
    removedPatientGoals.push(this);
  }

  isSelectedForSaving() {
    return selectedPatientGoals.find(
      (goal) => goal.goalTemplateId == this.goalTemplateId
    )
      ? true
      : false;
  }

  isSelectedForDeletion() {
    return removedPatientGoals.find(
      (goal) => goal.goalTemplateId == this.goalTemplateId
    )
      ? true
      : false;
  }

  static allPatientGoals() {
    return allPatientGoals;
  }

  static selectedPatientGoals() {
    return selectedPatientGoals;
  }

  static findById(id) {
    return allPatientGoals.find((goal) => goal.id == id);
  }

  static findByTemplateId(id) {
    return allPatientGoals.find((goal) => goal.goalTemplateId == id);
  }

  static clearGoals() {
    selectedPatientGoals = [];
    allPatientGoals = [];
    removedPatientGoals = [];
  }
}
